import React, { useEffect, useState } from "react";
import {
  FormControl,
  Box,
  InputLabel,
  Input,
  List,
  ListItem,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { getAllPurposes, getVendorById } from "../services/httpCalls";
import { useRecoilValue } from "recoil";
import { vendorDetailsClicked } from "../store/gloabalState";
import { useLocation } from "react-router-dom";

export function MultiSelect(props) {
  const [list, setList] = useState([]);
  const [active, setActive] = useState(false);
  const [purposeCodes, setPurposeCodes] = useState([]);
  const [searchInput, setSearchInput] = useState();
  const [added, setAdded] = useState([]);
  const [flag, setFlag] = useState(false);
  const [preFetchFlag, setPreFetchFlag] = useState(true);
  const vendorDetails = useRecoilValue(vendorDetailsClicked);
  const url = useLocation();

  useEffect(() => {
    if (vendorDetails && preFetchFlag) {
      preFetch();
    }
    getAllPurposes(searchInput).then((res) => {
      setList(res);
    });
    setFlag(false);
    if (props.clear) {
      setPurposeCodes([]);
      setAdded([]);
      props.setClear(false);
    }
  }, [flag, props.clear, vendorDetails]);

  const preFetch = () => {
    let pAdded = [];
    let pCodes = [];
    if (vendorDetails?.paymentPurposeList?.length) {
      vendorDetails.paymentPurposeList.forEach((elem) => {
        pAdded.push(elem.id);
        pCodes.push(elem);
      });
      setAdded(pAdded);
      setPurposeCodes(pCodes);
      setPreFetchFlag(false);
    }
  };

  const addPurposes = (e) => {
    let pAdded = added;
    let pCodes = purposeCodes;
    if (pAdded.includes(e.id)) {
      let index = pAdded.indexOf(e.id);
      pAdded.splice(index, 1);
      setAdded(pAdded);
      let indexCode = pCodes.indexOf(e);
      pCodes.splice(indexCode, 1);
      setPurposeCodes(pCodes);
    } else {
      pAdded.push(e.id);
      setAdded(pAdded);
      pCodes.push(e);
      setPurposeCodes(pCodes);
    }
    setSearchInput("");
    setFlag(true);
  };

  const makeSuggestedList = () => {
    setActive(false);
    setSearchInput("");
    let pCodesList = [];
    purposeCodes.forEach((elem) => {
      pCodesList.push(elem.id);
    });
    props.setSuggestedList(pCodesList);
  };

  const changeList = async (e) => {
    setSearchInput(e);
    if (e.length > 1) {
      await getAllPurposes(e).then((res) => {
        setList(res);
        setActive(true);
      });
    } else if (e.length === 0) {
      await getAllPurposes(e).then((res) => {
        setList(res);
        setActive(true);
      });
    }
  };
  useEffect(() => {
    if (url.pathname === "/addvendor") {
      setPurposeCodes([]);
      setAdded([]);
    }
  }, [url.pathname]);
  return (
    <Box>
      {purposeCodes.length ? (
        <Box className="tag_wrap">
          <Typography variant="h6" sx={{ fontSize: "14px", fontWeight: "600" }}>
            Selected Purposes ({purposeCodes.length}) :{" "}
          </Typography>
          {purposeCodes.map((elem, i) => {
            return (
              <div className="tag_" key={i}>
                {elem.paymentPurposeCodeAsPerRBI}
              </div>
            );
          })}
        </Box>
      ) : (
        ""
      )}
      <FormControl
        variant="standard"
        sx={{
          width: "300px",
          display: "block",
          marginTop: ".5rem",
          position: "relative",
        }}
      >
        <InputLabel htmlFor={props.id}>{props.label}</InputLabel>
        <Input
          value={searchInput}
          onChange={(e) => changeList(e.target.value)}
          id={props.id}
          sx={{ width: "100%" }}
          autoComplete={"off"}
          onClick={() => setActive(true)}
        />
        <Box
          sx={{
            width: "100%",
            maxWidth: 360,
            position: "absolute",
            bgcolor: "#fff",
            border: "1px solid #a2a2a2",
            zIndex: "9",
            display: active ? "block" : "none",
          }}
        >
          <List sx={{ maxHeight: "300px", overflowY: "auto" }}>
            {list.length
              ? list.map((elem, i) => (
                  <ListItem
                    key={i}
                    disableGutters
                    sx={{ cursor: "pointer", padding: ".5rem" }}
                  >
                    <FormControlLabel
                      sx={{ fontSize: "14px" }}
                      control={
                        <Checkbox
                          checked={added.includes(elem.id) ? true : false}
                          onChange={(e) => addPurposes(elem)}
                        />
                      }
                      label={
                        elem.paymentPurposeCodeAsPerRBI +
                        " - " +
                        elem.paymentPurposeDescriptionAsPerRBI
                      }
                    ></FormControlLabel>
                  </ListItem>
                ))
              : ""}
          </List>
          <Box
            sx={{
              position: "absolute",
              bottom: "-26px",
              zIndex: 9,
              width: "100%",
              border: "1px solid #a2a2a2",
              bgcolor: "#fff",
              textAlign: "right",
              display: active ? "block" : "none",
            }}
          >
            <Button onClick={makeSuggestedList}>Done</Button>
          </Box>
        </Box>
      </FormControl>
    </Box>
  );
}
